export default "__VITE_ASSET__DgalsWDO__"